import { Accordion, AccordionDetails, AccordionSummary, Box, Button, ButtonGroup, Dialog, InputLabel, List, ListItem, Paper, Stack, Tab, Tabs, Tooltip, Typography, tooltipClasses } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import styles from '../../styles/components/submissionUser.module.scss'
import MinimizeIcon from '../../public/assets/icons/MinimizeIcon'
import ExpandMoreIcon from '../../public/assets/icons/ExpandMoreIcon'
import CopyvsidIcon from '../../public/assets/icons/CopyvsidIcon'
import PerfectScrollbar from "react-perfect-scrollbar"
import "react-perfect-scrollbar/dist/css/styles.css"
import { styled } from '@mui/material/styles'
import ManagerPendingVideoFeatured from '../ManagerPendingVideoFeatured/ManagerPendingVideoFeatured'
import CopyIndexIcon from '../../public/assets/icons/CopyIndexIcon'
import DownloadVideoIcon from '../../public/assets/icons/DownloadVideoIcon'
import PropTypes from 'prop-types'
import videoImage from '../../public/assets/images/videoPageImg.png'
import TextZoomIcon from '../../public/assets/icons/TextZoomIcon'
import VideoUrlIcon from '../../public/assets/icons/VideoUrlIcon'
import FileAttachIcon from '../../public/assets/icons/FileAttachIcon'
import Signature from '../../public/assets/images/signature.png'
import CopysubIcon from '../../public/assets/icons/CopysubIcon'
import assest from '../../json/assest'
import VISDaccordian from '../VISDaccordian/VISDaccordian'

const OriginalVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 237,
        borderRadius: "10px",
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        padding: "9px 13px",
        [`& p`]: {
            color: "#000",
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "14px"
        }
    },
}));

const SocialVideoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} followCursor />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 237,
        borderRadius: "10px",
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        padding: "9px 13px",
        [`& p`]: {
            color: "#000",
            fontSize: "12px",
            fontWeight: "500",
            lineHeight: "14px"
        }
    },
}));

const PostInfoTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="top-end" />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        maxWidth: 199,
        borderRadius: "10px 10px 0 10px",
        color: "#000",
        boxShadow: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)",
        padding: "10px",
        margin: "0 !important"
    },
}));

const dialogContainer = {
    [`.MuiDialog-container`]: {
        [`.MuiDialog-paper`]: {
            marginTop: "48px",
            boxShadow: "none",
            borderRadius: "10px !important",
            [`.MuiDialogContent-root`]: {
                padding: "0 11px"
            }
        }
    },
};

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>{children}</>
            )}
        </Box>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const attachFileLoop = [
    {
        fileName: "5028537_5563370603774986.png"
    }
]

export default function SubmissionUser() {
    const [expanded, setExpanded] = React.useState(false);
    const [vsidSuccess, setVsidSuccess] = React.useState(false);
    const [openLargeModal, setOpenLargeModal] = React.useState(false);

    const handleChange =
        (panel) => (event, isExpanded) => {
            setExpanded(isExpanded ? panel : false);
        };

    const handleOpenClick = () => setOpenLargeModal(true)
    const handleCloseClick = () => setOpenLargeModal(false)

    const [openProceed, setOpenProceed] = React.useState(false);
    const handleClickOpenProceed = () => {
        setOpenProceed(true);
    };

    const [value, setValue] = React.useState("");
    const [lisitem, setListItem] = React.useState([]);
    const [listIndex, setListIndex] = React.useState(-1);

    const addList = () => {
        setListItem([...lisitem, value]);
        setValue("");
    };

    const removeItem = (index) => {
        setListIndex(index);
    };

    useEffect(() => {
        const filterList = lisitem.filter((data, index) => index !== listIndex);
        setListItem(filterList);
        setListIndex(-1);
    }, [listIndex]);

    const [socialValue, setsocialValue] = React.useState("");
    const [socialLisitem, setsocialListItem] = React.useState([]);
    const [socialListIndex, setsocialListIndex] = React.useState(-1);

    const addListsocial = () => {
        setsocialListItem([...socialLisitem, value]);
        setsocialValue("");
    };

    const removeItemsocial = (index) => {
        setsocialListIndex(index);
    };

    useEffect(() => {
        const filterList = socialLisitem.filter((data, index) => index !== socialListIndex);
        setsocialListItem(filterList);
        setsocialListIndex(-1);
    }, [socialListIndex]);

    // const [unreachable, setUnreachable] = useState(true)
    const [copywriteHighlight, setCopywriteHighlight] = useState(true)
    // const [expanded, setExpanded] = React.useState(false);

    // const handleChange =
    //     (panel) => (event, isExpanded) => {
    //         setExpanded(isExpanded ? panel : false);
    //     };

    const [modalopen, setModalopen] = React.useState(false);
    const [messagepertnerModal, setMessagepertnerModal] = React.useState(false)
    const [wesiteOnlyModal, setWesiteOnly] = React.useState(false)
    const [inquireModal, setInquireModal] = React.useState(false)
    const [videoreject, setVideoreject] = React.useState(false)
    const [rejection, setRejection] = React.useState(false)
    const [videoDuplicationYes, setvideoDuplicationYes] = React.useState(false)
    const [videoDuplicationNo, setvideoDuplicationNo] = React.useState(false)

    const handleClickOpen = () => {
        setModalopen(true);
    };

    const handleClose = () => {
        setModalopen(false);
    };

    const partnerModalOpen = () => {
        setMessagepertnerModal(true)
    }

    const partnerModalClose = () => {
        setMessagepertnerModal(false)
    }

    const inquireModalOpen = () => {
        setInquireModal(true)
    }
    const inquireModalClose = () => {
        setInquireModal(false)
    }

    const wesiteOnlyModalOpen = () => {
        setWesiteOnly(true)
    }
    const wesiteOnlyModalClose = () => {
        setWesiteOnly(false)
    }

    const videorejectModalOpen = () => {
        setVideoreject(true)
    }

    const videorejectClose = () => {
        setVideoreject(false)
    }

    const rejectionModalOpen = () => {
        setRejection(true)
    }

    const rejectionModalClose = () => {
        setRejection(false)
    }

    const videoDuplicationModalYesOpen = () => {
        setvideoDuplicationYes(true)
    }

    const videoDuplicationModalYesClose = () => {
        setvideoDuplicationYes(false)
    }

    const videoDuplicationModalNoOpen = () => {
        setvideoDuplicationNo(true)
    }

    const videoDuplicationModalNoClose = () => {
        setvideoDuplicationNo(false)
    }

    const [teamMsg, setTeamMsg] = React.useState(0);

    const handleTeamMsg = (event, newValue) => {
        setTeamMsg(newValue);
    };

    const [teamMsg1, setTeamMsg1] = React.useState(0);

    const handleTeamMsg1 = (event, newValue) => {
        setTeamMsg1(newValue);
    };

    const [snackOpen, setSnackOpen] = React.useState(false);

    const handleSnackbarClick = () => {
        setSnackOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackOpen(false);
    };

    const [websiteonlySnack, setWebsiteonlySnack] = React.useState(false);
    const [rejectSnack, setRejectSnack] = React.useState(false);
    const [rejectJustificationSnack, setRejectJustificationSnack] = React.useState(false);
    const [vdoduplicationSnack, setVdoduplication] = React.useState(false);

    const handleWebsiteonlyClick = () => {
        setWebsiteonlySnack(true);
    };

    const handleWebsiteonlyClose = () => {
        setWebsiteonlySnack(false);
    };

    const handleRejectClick = () => {
        setRejectSnack(true);
    };

    const handleRejectClose = () => {
        setRejectSnack(false);
    };

    const handleRejectJustificationClick = () => {
        setRejectJustificationSnack(true);
    };

    const handleRejectJustificationClose = () => {
        setRejectJustificationSnack(false);
    };

    const handlevdoduplicationSnackClick = () => {
        setVdoduplication(true);
    };

    const handlevdoduplicationSnackClose = () => {
        setVdoduplication(false);
    };

    // const [vsidSuccess, setVsidSuccess] = React.useState(false);
    const textRef = useRef(null);
    const textRefPost = useRef(null);
    const handleCopyClick = () => {
        if (textRef.current) {
            textRef.current.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Unable to copy text: ', err);
            }
            window.getSelection().removeAllRanges();
        }
    };
    const handleCopyPostUrlClick = () => {
        if (textRefPost.current) {
            textRefPost.current.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('Unable to copy text: ', err);
            }
            window.getSelection().removeAllRanges();
        }
    };

    const [alert, setAlert] = useState(true);
    const handleRemoveClick = () => {
        setAlert(false)
    }

    return (
        <>
            <Box className={`${styles.accItems} ${styles.vsidAcc}`}>
                <Accordion
                    expanded={expanded === "vsid"}
                    onChange={handleChange("vsid")}
                >
                    <AccordionSummary
                        expandIcon={
                            expanded === "vsid" ? <MinimizeIcon /> : <ExpandMoreIcon />
                        }
                        aria-controls="vsidbh-content"
                        id="vsidbh-header"
                    >
                        {vsidSuccess ? <>
                            <Typography variant="h2"><span>This video is good to go! It doesn't match any previous submissions</span></Typography>
                        </>
                            :
                            <>
                                <Typography variant="h2"><span>*Heads-up! We have received one or more submissions from this user:</span></Typography>
                                <List disablePadding className={styles.vsidBtngroup}>
                                    <ListItem className={styles.greenBtn}>SUBID 15645</ListItem>
                                    <ListItem className={styles.redBtn}>SUBID 15645</ListItem>
                                    <ListItem className={styles.redBtn}>SUBID 15645</ListItem>
                                </List>
                            </>
                        }

                    </AccordionSummary>
                    <AccordionDetails>
                        <List disablePadding className={styles.vsidmatchList}>
                            <ListItem>
                                <Box className={styles.panelLeftItem}>
                                    <Typography variant='body1' className={styles.titleText}>Does this submission match</Typography>
                                    <Button endIcon={<CopyvsidIcon icon={true}/>} className={styles.greenVSIDbtn}>SUBID 15645</Button>
                                    <Typography variant='body1'>?</Typography>
                                </Box>
                                <ButtonGroup>
                                    <Button className={styles.yesAdd} onClick={handleOpenClick}>Verify</Button>
                                </ButtonGroup>
                            </ListItem>
                            <ListItem>
                                <Box className={styles.panelLeftItem}>
                                    <Typography variant='body1' className={styles.titleText}>Does this submission match</Typography>
                                    <Button endIcon={<CopyvsidIcon icon={false}/>} className={styles.btnPinkvsid}>SUBID 15645</Button>
                                    <Typography variant='body1'>?</Typography>
                                </Box>
                                <ButtonGroup>
                                    <Button className={styles.yesAdd} onClick={handleOpenClick}>Verify</Button>

                                </ButtonGroup>
                            </ListItem>
                            <ListItem>
                                <Box className={styles.panelLeftItem}>
                                    <Typography variant='body1' className={styles.titleText}>Does this submission match</Typography>
                                    <Button endIcon={<CopyvsidIcon icon={false}/>} className={styles.btnPinkvsid}>SUBID 15645</Button>
                                    <Typography variant='body1'>?</Typography>
                                </Box>
                                <ButtonGroup>
                                    <Button className={styles.yesAdd} onClick={handleOpenClick}>Verify</Button>

                                </ButtonGroup>
                            </ListItem>
                        </List>
                    </AccordionDetails>
                </Accordion>
            </Box>

            <VISDaccordian/>

            <Dialog
                open={openLargeModal}
                onClose={handleCloseClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        width: "100%",
                        maxWidth: "89.688%",
                        position: "relative",
                        background: "#fff",

                    }
                }}
                sx={dialogContainer}
                className={styles.subUserInnermodal}
            >
                <Box className={styles.pageCopyVideo}>
                    <PerfectScrollbar className={styles.videoDetailsScroll}>
                        <Stack
                            direction={"row"}
                            flexWrap={"wrap"}
                            className={styles.copywritterVideoWrapper}
                        >
                            <Box className={styles.videoColLeft}>
                                <Paper className={styles.vdoCard}>
                                    <Box className={styles.videoBox} onClick={handleClickOpenProceed}>
                                        <img src={videoImage} width={701} height={435} alt="" />
                                        <ManagerPendingVideoFeatured />
                                    </Box>
                                    <Box className={styles.videoInput}>
                                        <input
                                            type="text"
                                            ref={textRef}
                                            value="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOV"
                                            readOnly
                                        />
                                        <Button onClick={handleCopyClick}>
                                            <CopyIndexIcon />
                                        </Button>
                                    </Box>
                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.vdoDesBtngrp}>
                                        <Button className={styles.btnApprove}>Yes, The videos match</Button>
                                        <Button className={styles.btnReject}> No, the videos are different</Button>
                                        <Button className={styles.vdoDwnldBtn} startIcon={<DownloadVideoIcon />}>Download Video</Button>
                                    </Stack>
                                </Paper>
                                <Paper className={`${styles.comWhiteBox} ${styles.titlePaperBox} ${styles.vdoDetailsCard}`}>
                                    <Box className={styles.paperHeading}>
                                        <Typography variant="h2">
                                            <span>Video Details</span>
                                        </Typography>
                                    </Box>
                                    <Box className={styles.vdodetailInner}>
                                        <Box className={styles.vdoUrlGroup}>
                                            <Typography variant="caption" className={styles.formLabel}>Public Post URL</Typography>
                                            <Box className={styles.videoInput}>
                                                <input
                                                    type="text"
                                                    ref={textRefPost}
                                                    value="Https://downloads.viralsnare.com/videos/2lKiIrdf5451df1JKYKpWpb.MOVvvvv"
                                                    readOnly
                                                />
                                                <Button onClick={handleCopyPostUrlClick}>
                                                    <CopyIndexIcon />
                                                </Button>
                                            </Box>
                                        </Box>
                                        <Box className={styles.titleGroup}>
                                            <Typography variant="caption" className={styles.formLabel}>Title</Typography>
                                            <Typography variant="body2" className={styles.formPara}>Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away</Typography>
                                        </Box>
                                        <Box className={styles.descriptionGroup}>
                                            <Typography variant="caption" className={styles.formLabel}>Description:</Typography>
                                            <Typography variant="body2" className={styles.formPara}>Fusce eget lacus non turpis porttitor gravida sit amet quis tellus. Morbi tempus finibus elit in ultrices. Nunc sagittis purus nisl, eu elementum risus faucibus vitae. Integmolestie, ex sit amet semd mauris odimolestie, met semd mauris odimolestie, ex sit amet semd maurier molestie, ex sit amet semd mauris odidgfgo... <Button><TextZoomIcon /></Button></Typography>
                                        </Box>
                                        <Stack direction={'row'} alignItems={'center'} className={styles.filmingGrid}>
                                            <Box className={`${styles.filmingLocaton} ${styles.Col}`}>
                                                <Typography variant="caption" className={styles.formLabel}>Filming Location</Typography>
                                                <Typography variant="body2" className={styles.formPara}>Los Angeles, California, United States</Typography>
                                            </Box>
                                            <Box className={`${styles.filmingDate} ${styles.Col}`}>
                                                <Typography variant="caption" className={styles.formLabel}>Filming Date</Typography>
                                                <Typography variant="body2" className={styles.formPara}>January 25, 2019</Typography>
                                            </Box>
                                        </Stack>
                                    </Box>
                                    <Box className={styles.mediaFilebtn}>
                                        <OriginalVideoTooltip
                                            title={
                                                <React.Fragment>
                                                    <Typography color="inherit">Partner is currently adding a file.<br /> Please try again in a few minutes.</Typography>
                                                </React.Fragment>
                                            }
                                        >
                                            <Button startIcon={<VideoUrlIcon />}>Add original video file (VS Link)</Button>
                                        </OriginalVideoTooltip>
                                    </Box>
                                    <Box className={styles.mediaFilebtn}>
                                        <SocialVideoTooltip
                                            title={
                                                <React.Fragment>
                                                    <Typography color="inherit">Partner is adding a post URL.<br /> Please try again in a few minutes.</Typography>
                                                </React.Fragment>
                                            }
                                        >
                                            <Button startIcon={<FileAttachIcon />}>Add social media post URL</Button>
                                        </SocialVideoTooltip>

                                    </Box>
                                </Paper >
                            </Box >
                            <Box className={styles.videoColRight}>
                                <Paper className={`${styles.comWhiteBox} ${styles.submitterDetails}`}>
                                    <Box className={styles.paperHeading}>
                                        <Typography variant="h2">
                                            <span>Submitter Details</span>
                                        </Typography>
                                    </Box>
                                    <Stack direction={'row'} flexWrap={'wrap'} className={styles.ownerDetailsGrid}>
                                        <Box className={`${styles.gridCol1} ${styles.Col1}`}>
                                            <Box className={`${styles.formGroup} ${styles.formName}`}>
                                                <Typography variant="h6">Full Name</Typography>
                                                <Typography variant="body2">Saimon Jhonson</Typography>
                                            </Box>
                                            <Box className={`${styles.formGroup} ${styles.formNumber}`}>
                                                <Typography variant="h6">Phone Number</Typography>
                                                <Typography variant="body2">+1 234 567 8290</Typography>
                                            </Box>
                                        </Box>
                                        <Box className={`${styles.gridCol2} ${styles.Col1}`}>
                                            <Box className={`${styles.formGroup} ${styles.formEmail}`}>
                                                <Typography variant="h6">Email Address</Typography>
                                                <Typography variant="body2" className={styles.mailAdd}>jognsmith@gmail.com</Typography>
                                            </Box>
                                            <Box className={`${styles.formGroup} ${styles.formSocial}`}>
                                                <Typography variant="h6">Social Media Handle</Typography>
                                                <Typography variant="body2">Saimon Jhonson</Typography>
                                            </Box>
                                        </Box>
                                        <Box className={`${styles.gridCol3} ${styles.Col1}`}>
                                            <Box className={`${styles.formGroup} ${styles.formDob}`}>
                                                <Typography variant="h6">Date Of Birth</Typography>
                                                <Typography variant="body2">05/17/2002</Typography>
                                            </Box>
                                            <Box className={`${styles.formGroup} ${styles.formSignature}`}>
                                                <Typography variant="h6">Signature</Typography>
                                                <img src={Signature} alt="" className={styles.signature} />
                                            </Box>
                                        </Box>
                                    </Stack>
                                </Paper>
                                <Paper className={copywriteHighlight ? `${styles.comWhiteBox} ${styles.copywright} ${styles.copywritePaperHighlight}` : `${styles.comWhiteBox} ${styles.copywright}`}>
                                    <Box className={styles.paperHeading}>
                                        <Typography variant="h2">
                                            <span>Copyrights Ownership</span>
                                        </Typography>
                                    </Box>
                                    <List disablePadding className={styles.ownerListItme}>
                                        <ListItem disablePadding>
                                            <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                                <Box className={styles.listRowLeft}>
                                                    <Typography variant='h4'>The Person Who Filmed This Video Is</Typography>
                                                    <Typography variant='body2'>Me</Typography>
                                                </Box>
                                            </Stack>
                                        </ListItem>
                                        <ListItem disablePadding>
                                            <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                                <Box className={styles.listRowLeft}>
                                                    <Typography variant='h4'>Are There People Appearing In The Video?</Typography>
                                                    <Typography variant='body2' className={styles.bgWrap}>Yes</Typography>
                                                    <Box className={`${styles.ansAre}`}>
                                                        <Box className={styles.listRowRight}>
                                                            <Typography variant='h4'>Who Are They? </Typography>
                                                            <Typography variant='body2' className={styles.textorng}>my friends</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </ListItem>
                                        <ListItem disablePadding>
                                            <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                                <Box className={styles.listRowLeft}>
                                                    <Typography variant='h4'>Did You Send/Submit/Upload This Video To a Website and/or Social Media Account? </Typography>
                                                    <Typography variant='body2' className={styles.bgWrap}>Yes, A YouTube Account</Typography>
                                                    <Box className={`${styles.ansAre}`}>
                                                        <Box className={styles.listRowRight}>
                                                            <Typography variant='h4'>Where Did You Submit It?</Typography>
                                                            <Typography variant='body2' className={styles.textorng}>Our Instagram, Facebook And YouTube</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </ListItem>
                                        <ListItem disablePadding>
                                            <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                                <Box className={styles.listRowLeft}>
                                                    <Typography variant='h4'>Did Anyone Reach You About Using This Video?</Typography>
                                                    <Typography variant='body2' className={styles.bgWrap}>Yes, Another Company Contacted Me</Typography>
                                                    <Box className={`${styles.ansAre}`}>
                                                        <Box className={styles.listRowRight}>
                                                            <Typography variant='h4'>Please Share The Name Of The Company/Page With Us</Typography>
                                                            <Typography variant='body2' className={styles.textorng}>Viralhog, Jukin</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </ListItem>
                                        <ListItem disablePadding>
                                            <Stack direction={'row'} flexWrap={'wrap'} className={styles.listStack}>
                                                <Box className={styles.listRowLeft}>
                                                    <Typography variant='h4'>Did You Sign A Licensing Agreement For This Video With Another Company/Page?</Typography>
                                                    <Typography variant='body2' className={styles.bgWrap}>Yes, I Have Signed An Exclusive Agreement</Typography>
                                                    <Box className={`${styles.ansAre}`}>
                                                        <Box className={styles.listRowRight}>
                                                            <Typography variant='h4'>Name of the Company/Page? </Typography>
                                                            <Typography variant='body2' className={styles.textorng}>Company Name</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </ListItem>
                                    </List>
                                </Paper>
                                <Paper className={`${styles.comWhiteBox} ${styles.submissionInfo}`}>
                                    <Box className={styles.paperHeading}>
                                        <Typography variant="h2">
                                            <span>Submission Information</span>
                                        </Typography>
                                    </Box>
                                    <Stack direction={'row'} flexWrap={'wrap'} className={styles.subInfoRow}>
                                        <Box className={`${styles.infoGrid1} ${styles.Col}`}>
                                            <Box className={styles.formGroup}>
                                                <Typography variant='h6'>Terms of Submission</Typography>
                                                <Typography variant='body2'>Agreed | Exclusive License</Typography>
                                            </Box>
                                            <Box className={styles.formGroup}>
                                                <Typography variant='h6'>User IP Address</Typography>
                                                <Typography variant='body2'>17.172.224.47</Typography>
                                            </Box>
                                            <Box className={styles.formGroup}>
                                                <Typography variant='h6'>SUBID <Button><CopysubIcon /></Button></Typography>
                                                <Typography variant='body2'>17171</Typography>
                                            </Box>
                                        </Box>
                                        <Box className={`${styles.infoGrid2} ${styles.Col}`}>
                                            <Box className={styles.formGroup}>
                                                <Typography variant='h6'>Terms of Service</Typography>
                                                <Typography variant='body2'>Agreed</Typography>
                                            </Box>
                                            <Box className={styles.formGroup}>
                                                <Typography variant='h6'>Country</Typography>
                                                <Typography variant='body2'>United States</Typography>
                                            </Box>
                                            <Box className={styles.formGroup}>
                                                <Typography variant='h6'>Revenue Share:</Typography>
                                                <Typography variant='body2'>50%</Typography>
                                            </Box>
                                        </Box>
                                        <Box className={`${styles.infoGrid3} ${styles.Col}`}>
                                            <Box className={styles.formGroup}>
                                                <Typography variant='h6'>Submission Date</Typography>
                                                <Typography variant='body2'>August 23, 2021 at 11:15:34 PM UTC</Typography>
                                            </Box>
                                            <Box className={styles.formGroup}>
                                                <Typography variant='h6'>Acquired By</Typography>
                                                <Typography variant='body2'>Acquisitor name</Typography>
                                            </Box>
                                        </Box>
                                    </Stack>
                                </Paper>
                            </Box >
                        </Stack >
                    </PerfectScrollbar >
                </Box >
            </Dialog>
        </>
    )
}
